import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, type Firestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Guard against environments where Firebase env vars are absent (Storybook, Chromatic, CI).
// initializeApp + getAuth throw auth/invalid-api-key at module-load time when the
// API key is missing, crashing Storybook before any story renders.
const app = import.meta.env.VITE_FIREBASE_API_KEY
  ? initializeApp(firebaseConfig)
  : null;

export const auth = (app ? getAuth(app) : {}) as Auth;
export const db = (app ? getFirestore(app) : {}) as Firestore;

// Connect to local emulators when VITE_USE_EMULATOR=true (set in .env.local).
// Must be called immediately after getAuth/getFirestore, before any SDK calls.
if (app && import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
}
